import React, { useState, useCallback } from 'react'
import { Page, Header, CustomButton, ModalConfirmacao } from 'components'
import { Divider, Grid, TextField, Typography } from '@material-ui/core'
import { useFormState } from 'hooks/useFormState'
import useRouter from 'utils/useRouter'
import { FileManager } from 'components/FileManager'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import useStyles from './styles'
import { useParams } from 'react-router'

const schema = {
  motivoCancelamento: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
}

export const CancelarExame = (props) => {
  const { route } = props
  const classes = useStyles()
  const params = useParams()
  const router = useRouter()
  const exameRealizadoService = useExameRealizadoService()

  const [abrirConfirmacao, setAbrirConfirmacao] = useState(false)
  const [processandoCancelamentoExame, setProcessandoCancelamentoExame] = useState(false)

  const cancelarExameForm = useFormState(schema, {
    motivoCancelamento: '',
    arquivos: [],
  })

  const setArquivosUpload = useCallback((ids) => {
    cancelarExameForm.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        arquivos: ids,
      },
    }))
  }, [])

  const handleOpenConfirmacao = () => {
    setAbrirConfirmacao(true)
  }

  const handleConfirmar = async () => {
    try {
      await exameRealizadoService.cancelarExameRealizadoService(
        cancelarExameForm.formState.values,
        params.idExameRealizado,
        setProcessandoCancelamentoExame
      )
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${params.idExameSolicitado}`)
    } catch (error) {
      console.error('Erro ao cancelar exame:', error)
    }
  }

  const isFormValid = cancelarExameForm.formState.values.motivoCancelamento?.trim().length > 0

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />

      <form onSubmit={(e) => e.preventDefault()} style={{ marginTop: '24px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Motivo do Cancelamento"
              minRows={5}
              name="motivoCancelamento"
              fullWidth
              multiline
              variant="outlined"
              value={cancelarExameForm.formState.values.motivoCancelamento}
              onChange={cancelarExameForm.handleChange}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} className={classes.item}>
            <Typography variant="body2" style={{ marginBottom: '12px', fontWeight: 600 }}>
              ARQUIVOS RELACIONADOS
            </Typography>
            <FileManager
              rotaUpload="/arquivo/cancelarExameSolicitado"
              rotaLoadImagem="/arquivo/cancelarExameSolicitado"
              setArquivosPai={setArquivosUpload}
              arquivosIniciais={[]}
              tipos={['image', 'pdf']}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider style={{ margin: '16px 0' }} />
          </Grid>

          <Grid item container justifyContent="space-between" alignItems="center">
            <Grid item>
              <CustomButton variant="outlined" colorType="primary" startIcon={<ArrowBackIcon />} onClick={() => router.history.goBack()}>
                Voltar
              </CustomButton>
            </Grid>
            <Grid item>
              <CustomButton
                variant="contained"
                colorType="error"
                startIcon={<CheckIcon />}
                disabled={!isFormValid}
                onClick={handleOpenConfirmacao}
              >
                Confirmar Cancelamento
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
      </form>

      <ModalConfirmacao
        aberto={abrirConfirmacao}
        onClose={() => setAbrirConfirmacao(false)}
        onConfirm={handleConfirmar}
        processando={processandoCancelamentoExame}
        titulo="CONFIRMAR CANCELAMENTO"
        confirmarLabel="Confirmar"
        maxWidth="sm"
      >
        <div style={{ marginTop: '15px' }}>
          <Typography variant="body1" style={{ marginBottom: '15px' }}>
            Tem certeza que deseja cancelar este exame solicitado? Esta ação não poderá ser desfeita.
          </Typography>
          {cancelarExameForm.formState.values.motivoCancelamento && (
            <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.02)', padding: '12px', borderRadius: '8px', borderLeft: '4px solid #f44336' }}>
              <Typography variant="caption" color="textSecondary" style={{ display: 'block', fontWeight: 600 }}>
                MOTIVO DO CANCELAMENTO:
              </Typography>
              <Typography variant="body2" style={{ whiteSpace: 'pre-wrap', marginTop: '4px' }}>
                {cancelarExameForm.formState.values.motivoCancelamento}
              </Typography>
            </div>
          )}
        </div>
      </ModalConfirmacao>
    </Page>
  )
}
